import { useEffect, useState } from 'react';
import { useIdentity } from './IdentityContext';
import { imageUrl as defaultImageUrl } from '../data/imageUrl';

// Plain <img src> can't attach an Authorization header, so admin-only draft/*
// images (unlike published/* ones, which the public site loads directly)
// have to be fetched via authFetch and turned into an object URL instead.
// `urlFn` defaults to the Collections imageUrl builder; pass categoryImageUrl
// for Categories images instead of duplicating this hook.
export default function useAuthedImage(image, urlFn = defaultImageUrl) {
  const { authFetch } = useIdentity();
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!image) {
      setSrc(null);
      return undefined;
    }
    let cancelled = false;
    let objectUrl = null;
    authFetch(urlFn(image))
      .then((r) => {
        if (!r.ok) throw new Error('Failed to load image');
        return r.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [authFetch, image, urlFn]);

  return src;
}
